<template>
  <el-row class="_login-app">
    <el-col :span="$store.state.isMB?24:24" :offset="$store.state.isMB?0:0">
      <div style="display:flex;flex-direction:column;height:100vh;padding-top:15vh">
      <div class="login_title"></div>
        <div class="login-box">
          <div class="title">用户登录</div>
          <template v-if="!forget">
            <el-form
              ref="form"
              size="large"
              :model="data"
              :rules="rules"
              @keyup.enter.native="login"
            >
              <el-form-item prop="LoginId">
                <el-input class="boxInp" prefix-icon="el-icon-user" v-model="data.LoginId" placeholder="登录账号">
                  <!-- <i slot="prefix" ></i> -->
                </el-input>
              </el-form-item>
              <el-form-item prop="Pwd">
                <el-input show-password prefix-icon="el-icon-lock" class="boxInp" type="password" v-model="data.Pwd" placeholder="登录密码" />
              </el-form-item>
              <el-row>
                <el-col :span="$store.state.isMB?13:16" style="padding-right:10px;">
                  <el-form-item prop="VerifyCode">
                    <el-input class="boxInp" prefix-icon="el-icon-key" v-model="data.VerifyCode" placeholder="填写验证码" />
                  </el-form-item>
                </el-col>
                <el-col :span="$store.state.isMB?11:8">
                  <s-identify style="margin-left:-3px;" :identifyCode="identifyCode" @refresh="refreshCode"></s-identify>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="$store.state.isMB?13:15" style="padding-right:10px;">
                  <el-form-item prop="Code">
                    <el-input v-model="data.Code" placeholder="短信验证码" />
                  </el-form-item>
                </el-col>
                <el-col :span="$store.state.isMB?11:9">
                  <el-button
                    :disabled="time!=0"
                    style="width:100%"
                    type="info"
                    plain
                    @click="sendCode(3)"
                  >
                    <span v-if="time==0">点击获取</span>
                    <span v-else>{{time}}s</span>
                  </el-button>
                </el-col>
              </el-row>-->
              <el-button
                size="large"
                :loading="loading"
                style="width:100%;border-radius:18px;background:#009966;color:#fff;"
                @click="login"
              >登录</el-button>
              <!-- <span class="forget-pwd" @click="forgetPwd(true)">忘记密码</span> -->
            </el-form>
          </template>
          <template v-else>
            <el-form ref="form" :model="data" :rules="rules" @keyup.enter.native="login">
              <el-form-item prop="LoginId">
                <el-input v-model="data.LoginId" placeholder="手机号码" />
              </el-form-item>
              <el-form-item prop="Pwd">
                <el-input show-password type="password" v-model="data.Pwd" placeholder="登录密码" />
              </el-form-item>
              <el-row>
                <el-col :span="$store.state.isMB?13:15" style="padding-right:10px;">
                  <el-form-item prop="Code">
                    <el-input v-model="data.Code" placeholder="短信验证码" />
                  </el-form-item>
                </el-col>
                <el-col :span="$store.state.isMB?11:9">
                  <el-button
                    :disabled="time!=0"
                    style="width:100%"
                    type="info"
                    plain
                    @click="sendCode(4)"
                  >
                    <span v-if="time==0">点击获取</span>
                    <span v-else>{{time}}s</span>
                  </el-button>
                </el-col>
              </el-row>
              <el-button
                size="large"
                :loading="loading"
                type="primary"
                style="width:100%;"
                @click="resetPwd"
              >重置密码</el-button>
              <span class="forget-pwd" @click="forgetPwd(false)">返回登录</span>
            </el-form>
          </template>
          <!-- <div style="margin:0 auto 30px;text-align:center;font-size:22px;font-family:'宋体';font-weight:bold;">产品质量追溯系统</div> -->
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import sIdentify from "@/components/common/sIdentify";

export default {
  components: {
    sIdentify,
  },
  data() {
    const validateCode = (rule, value, callback) => {
      if (this.identifyCode !== value) {
        this.data.VerifyCode = "";
        this.refreshCode();
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      api: require("@/api/sy/user").default,
      identifyCode: "",
      loading: false,
      data: {
        LoginId: "",
        Pwd: "",
        Code: "",
        VerifyCode: "",
      },
      forget: false, //忘记密码
      time: 0,
      interval: null,
      rules: {
        LoginId: [{ required: true, message: "请输入登录账号" }],
        Pwd: [{ required: true, message: "请输入登录密码" }],
        Code: [{ required: true, message: "请输入短信验证码" }],
        VerifyCode: [
          { required: true, message: "请输入验证码" },
          { validator: validateCode, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.refreshCode();
  },
  mounted() {
    let token = localStorage.getItem("token");
    if (token) {
      this.$store.dispatch("refreshToken").then((res) => {
        if (res.Code == 0) {
          this.$router.push("/dashboard").catch((err) => {});
        }
      });
    }
  },
  methods: {
    //3:登录验证码 4:重置密码
    sendCode(type = 3) {
      this.api.sendCode(this.data.LoginId, type).then((res) => {
        if (res.Code == 0) {
          let self = this;
          self.time = 120;
          this.interval = setInterval(function () {
            self.time -= 1;
            if (self.time <= 0) {
              clearInterval(self.interval);
            }
          }, 1000);
        } else {
          if (res.Msg == null) {
            res.Msg = "发送失败";
          }
          this.$message.error(res.Msg);
        }
      });
    },
    forgetPwd(data) {
      this.forget = data;
      this.data.Code = "";
      clearInterval(this.interval);
      this.time = 0;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    login() {
      this.$refs.form
        .validate()
        .then((res) => {
          if (!res) return false;
          this.loading = true;
          this.$store
            .dispatch("login", this.data)
            .then((res) => {
              console.log("login", res);
              if (res.Data.ChangePwd == true) {
                this.$store.dispatch("changeSetting", {
                  key: "fixedHeader",
                  value: false,
                });
                this.$router.push("/password").catch((err) => {});
              } else {
                this.$router.push("/dashboard").catch((err) => {});
              }
            })
            .catch((res) => {
              this.$message.error(res.Msg);
              this.loading = false;
              console.log(res);
            });
        })
        .catch((res) => {
          console.log(res);
        });
    },
    resetPwd() {
      this.$refs.form
        .validate()
        .then((valid) => {
          if (!valid) return false;
          this.loading = true;
          this.api.resetPwd(this.data).then((res) => {
            this.loading = false;
            if (res.Code == 0) {
              this.forgetPwd(false);
              this.data.Pwd = "";
              this.data.Code = "";
              this.$message.success(res.Msg);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch((res) => {
          this.loading = false;
          console.log(res);
        });
    },
    refreshCode() {
      this.identifyCode = "";
      for (let i = 0; i < 4; i++) {
        this.identifyCode += this.randomNum(0, 9);
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  },
};
</script>
<style lang="scss">
._login-app {
  .login_title{
    color: #fff;
    text-align: center;
    margin-bottom: 15vh;
    width: 100%;
    font-size: 44px;
    letter-spacing: 16px;
    @media screen and (max-width: 767px) {
      padding: 0 15%;
      font-size: 28px;
      margin-bottom: 10vh;
      letter-spacing: 2px;
    }
    @media screen and (min-width: 768px) and (max-width: 1600px) {
      margin-bottom: 13vh;
    }
  }
  @media screen and (max-width: 767px) {
    background-image: url("../assets/bgPic_MB.jpg");
    background-size: 100% 100%;
  }
  @media screen and (min-width: 768px) {
    background-image: url("../assets/bgPic.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }
  // background: linear-gradient(-30deg, #1736a0 0%, #6890e5 100%);
  .login-box {
    z-index: 1000;
    border-radius: 12px;
    width: 380px;
    margin: 0px auto;
    border: 1px solid #ebeef5;
    padding: 25px 25px 25px;
    background-color: #fff;
    border: 2px #00aaaa solid;
    // box-shadow: 2px 2px 12px 0 rgba(0, 0, 0, 0.1);
    @media screen and (max-width: 767px) {
      width: 80%;
      padding: 20px 25px 20px;
    }
    .title {
      height: 40px;
      font-weight: bold;
      font-family: "宋体";
      font-size: 18px;
      text-align: center;
      letter-spacing: 1px;
      @media screen and (max-width: 767px) {
        font-size: 18px;
      }
    }

    .forget-pwd {
      font-size: 16px;
      margin-top: 5px;
      display: inline-block;
      color: gray;
      cursor: pointer;
    }
    .el-input__inner {
      border-radius: 18px;
    }
  }
  .boxInp{
    .el-input__inner:focus{
      border-color: #009966;
    }
  }
}
</style>